import { GroupPostAttributesType, PostEditorState, PostGroupsType } from '../../../models/post-editor';
import { ActiveCustomizeIndexType } from '../states/ActiveCustomizeIndexProvider';
import { ImmutabilityContext } from '../states/effects/customImmutabilityContext';

export type OnStateUpdateCallbackFunction = (currentPost: GroupPostAttributesType) => GroupPostAttributesType;

export const postGroupStateUpdater = (
  state: PostEditorState,
  postGroupIndex: number,
  customizeIndex: ActiveCustomizeIndexType,
  postSection: 'schedule' | 'content',
  callback: OnStateUpdateCallbackFunction
): PostEditorState => {
  const { update: updateImmutable } = ImmutabilityContext;
  const customizeIndexContent =
    postSection === 'content' ? typeof customizeIndex === 'number' : customizeIndex === undefined;
  const customizeIndexSchedule =
    postSection === 'schedule' ? typeof customizeIndex === 'number' : customizeIndex === undefined;
  const customizeContentPerProfile =
    state.postGroups[postGroupIndex].customizeContentPerProfile && customizeIndexContent;
  const customizeSchedulePerProfile =
    state.postGroups[postGroupIndex].customizeSchedulePerProfile && customizeIndexSchedule;
  return updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        $apply: currentGroup => {
          if ((customizeContentPerProfile || customizeSchedulePerProfile) && typeof customizeIndex === 'number') {
            // update posts only since we are setting the customized portion or
            // total customize mode, update posts only and leave the group attributes
            return updateImmutable(currentGroup, {
              posts: {
                [customizeIndex]: currentPost => callback(currentPost)
              }
            });
          } else if ((customizeContentPerProfile || customizeSchedulePerProfile) && customizeIndex === undefined) {
            // we have partial customize on, but customized index is undefined, meaning we update the non customized portion,
            // so we want to update both individual posts (every single one of them) and the group attributes
            return updateImmutable<PostGroupsType>(currentGroup, {
              posts: {
                $apply: (currentPosts: GroupPostAttributesType[]) =>
                  currentPosts.map(currentPost => callback(currentPost))
              },
              groupPostAttributes: {
                $apply: currentGroupAttributes => callback(currentGroupAttributes)
              }
            });
          } else {
            // not customizing in any sense, so update just the group
            return updateImmutable<PostGroupsType>(currentGroup, {
              groupPostAttributes: {
                $apply: currentGroupAttributes => callback(currentGroupAttributes)
              }
            });
          }
        }
      }
    }
  });
};

export const postGroupCompleteUpdater = (
  state: PostEditorState,
  callback: OnStateUpdateCallbackFunction
): PostEditorState => {
  const { update: updateImmutable } = ImmutabilityContext;
  return updateImmutable(state, {
    postGroups: {
      $apply: (postGroups: PostGroupsType[]) =>
        postGroups.map(group => {
          return updateImmutable<PostGroupsType>(group, {
            groupPostAttributes: {
              $apply: currentGroup => callback(currentGroup)
            },
            posts: {
              $apply: (currentPosts: GroupPostAttributesType[]) =>
                currentPosts.map(currentPost => callback(currentPost))
            }
          });
        })
    }
  });
};
